import { formatearMoneda } from "../../config/moneda";
import ExportarReporte from "../ExportarReporte/ExportarReporte";

const VentasDetalleTabla = ({ detalle, filtros, paginas, cargando, onPagina, onTamanoPagina, exportFilters }) => (
  <section className="ventas-panel" aria-labelledby="ventas-detalle-titulo">
    <div className="ventas-panel-titulo">
      <div><h3 id="ventas-detalle-titulo">Detalle de ventas</h3><p>Comprobantes y productos del período seleccionado</p></div>
      <div className="ventas-panel-acciones"><span className="ventas-registros">{detalle.TotalRegistros || 0} registros</span><ExportarReporte endpoint="PISeunReportes/VentasDetalle" filters={exportFilters} nombre="Detalle de ventas" disabled={cargando} /></div>
    </div>
    <div className="ventas-tabla-wrap">
      <table className="ventas-tabla">
        <thead><tr><th>Fecha</th><th>Venta</th><th>Cliente</th><th>Producto</th><th>Operador</th><th>Pago</th><th className="num">Cantidad</th><th>Stock</th><th className="num">Neto</th><th className="num">IVA</th><th>Estado</th><th>Remito</th><th>Factura</th></tr></thead>
        <tbody>
          {(detalle.Lista || []).map((item, indice) => (
            <tr key={`${item.VentaId}-${item.MercaderiaId ?? "libre"}-${indice}`}>
              <td>{item.Fecha ? new Date(item.Fecha).toLocaleString("es-AR") : "-"}</td>
              <td>{item.VentaId}</td><td>{item.Cliente}</td><td>{item.Producto}</td><td>{item.Operador}</td><td>{item.FormaPago}</td>
              <td className="num">{Number(item.Cantidad || 0).toLocaleString("es-AR")}</td>
              <td>
                <strong>{item.EstadoStock || "NoAplica"}</strong>
                {Number(item.CantidadStockConsumida || 0) > 0 && <small> Descontado: {Number(item.CantidadStockConsumida).toLocaleString("es-AR")}</small>}
                {Number(item.CantidadSinStock || 0) > 0 && <small> Sin stock: {Number(item.CantidadSinStock).toLocaleString("es-AR")}</small>}
              </td>
              <td className="num">{formatearMoneda(item.Subtotal)}</td><td className="num">{formatearMoneda(item.Iva)}</td>
              <td>{item.EstadoVenta}</td><td>{item.Remito || "-"}</td><td>{item.FacturaId || "-"}</td>
            </tr>
          ))}
          {!detalle.Lista?.length && <tr><td colSpan="13" className="sin-datos">No hay ventas para los filtros seleccionados.</td></tr>}
        </tbody>
      </table>
    </div>
    <div className="ventas-paginacion">
      <label>Filas<select disabled={cargando} value={filtros.TamanoPagina} onChange={(e) => onTamanoPagina(Number(e.target.value))}><option>10</option><option>25</option><option>50</option><option>100</option><option>200</option></select></label>
      <span>Página {filtros.Pagina} de {paginas}</span>
      <div className="ventas-paginacion-acciones">
        <button type="button" disabled={filtros.Pagina <= 1 || cargando} onClick={() => onPagina(filtros.Pagina - 1)}>Anterior</button>
        <button type="button" disabled={filtros.Pagina >= paginas || cargando} onClick={() => onPagina(filtros.Pagina + 1)}>Siguiente</button>
      </div>
    </div>
  </section>
);

export default VentasDetalleTabla;
